import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import uuidv4 from 'uuid/v4';

import { CompetitionPropType, SeriesPropType } from '../../common/types';

import Spinner from '../../common/Spinner';
import Stats from '../../management/common/Stats';

const LOGO_PLACEHOLDER = '/assets/images/placeholder.png';
const DOWNLOAD_COOKIE_INTERVAL = 200;

class ArchiveStats extends Component {
  static propTypes = {
    competitions: PropTypes.arrayOf(CompetitionPropType).isRequired,
    competitionsLoading: PropTypes.bool.isRequired,
    serieses: PropTypes.arrayOf(SeriesPropType).isRequired,
    fetchStats: PropTypes.func.isRequired,
    stats: PropTypes.object.isRequired,
  };

  state = {
    statsCompetitionId: null,
    statsSeriesId: null,
    answersLoading: false,
    identifier: uuidv4(),
  };

  checkDownloadCookie = identifier => {
    if (document.cookie.includes(`download-${identifier}=`)) {
      this.setState({ answersLoading: false });
      return;
    }

    setTimeout(
      () => this.checkDownloadCookie(identifier),
      DOWNLOAD_COOKIE_INTERVAL
    );
  };

  onChooseCompetition = competitionId => {
    const { statsCompetitionId, statsSeriesId } = this.state;
    const empty = statsCompetitionId === competitionId;

    this.setState({
      statsCompetitionId: empty ? null : competitionId,
      statsSeriesId: empty ? null : statsSeriesId,
    });
  };

  onChooseSeries = seriesId => {
    const { statsCompetitionId, statsSeriesId } = this.state;
    const empty = statsSeriesId === seriesId;

    if (!empty) {
      this.props.fetchStats({
        competitionId: statsCompetitionId,
        id: seriesId,
      });
    }

    this.setState({
      statsSeriesId: empty ? null : seriesId,
    });
  };

  onDownloadAnswers = () => {
    const { identifier } = this.state;

    this.checkDownloadCookie(identifier);
    this.setState({ answersLoading: true, identifier: uuidv4() });
  };

  renderChooseCompetition = () => {
    const { competitions, competitionsLoading } = this.props;
    const { statsCompetitionId } = this.state;

    return (
      <>
        <div className="row justify-content-between mt-4 mb-3">
          <div className="col-auto d-flex align-items-center">
            <div className="HomeArchiveStats-choose-icon mr-4" />

            <h3 className="my-0">
              <FormattedMessage
                id="home-archive-stats-choose-competition"
                defaultMessage="Valitse kilpailu"
              />
            </h3>
          </div>
        </div>

        <div className="row">
          {competitionsLoading && (
            <div className="col">
              <Spinner center />
            </div>
          )}

          {!competitionsLoading &&
            competitions.map(competition => (
              <div
                key={competition.id}
                className="HomeArchiveStats-competition col-auto"
              >
                <button
                  type="button"
                  className={classNames(
                    'HomeArchiveStats-button',
                    'btn',
                    'btn-transparent',
                    'btn-lg',
                    'pl-3',
                    'd-flex',
                    'align-items-center',
                    { active: statsCompetitionId === competition.id }
                  )}
                  onClick={() => this.onChooseCompetition(competition.id)}
                >
                  <img
                    src={
                      competition.logo
                        ? competition.logoURL()
                        : LOGO_PLACEHOLDER
                    }
                    alt={competition.name}
                    className="HomeArchiveStats-competition-logo mr-4"
                  />

                  <p className="my-0">{competition.name}</p>
                </button>
              </div>
            ))}
        </div>
      </>
    );
  };

  renderChooseSeries = () => {
    const { serieses } = this.props;
    const { statsCompetitionId, statsSeriesId } = this.state;

    return (
      <>
        <div className="row justify-content-between mt-5 mb-3">
          <div className="col-auto d-flex align-items-center">
            <div className="HomeArchiveStats-choose-icon mr-4" />

            <h3 className="my-0">
              <FormattedMessage
                id="home-archive-stats-choose-series"
                defaultMessage="Valitse sarja"
              />
            </h3>
          </div>
        </div>

        <div className="row">
          {serieses
            .filter(s => s.competition_id === statsCompetitionId)
            .map(series => (
              <div key={series.id} className="col-auto">
                <button
                  type="button"
                  className={classNames(
                    'HomeArchiveStats-button',
                    'btn',
                    'btn-transparent',
                    'btn-lg',
                    'd-flex',
                    'align-items-center',
                    { active: statsSeriesId === series.id }
                  )}
                  onClick={() => this.onChooseSeries(series.id)}
                >
                  <p className="my-0">{series.name}</p>
                </button>
              </div>
            ))}
        </div>
      </>
    );
  };

  render() {
    const { stats } = this.props;

    const {
      statsCompetitionId,
      statsSeriesId,
      answersLoading,
      identifier,
    } = this.state;

    return (
      <div className="HomeArchiveStats">
        {this.renderChooseCompetition()}

        {!!statsCompetitionId && this.renderChooseSeries()}

        {!!statsSeriesId && (
          <div className="mt-5">
            <div className="row justify-content-between mb-5">
              <div className="col-auto d-flex align-items-center">
                <div className="HomeArchiveStats-stats-icon mr-4" />

                <h3 className="my-0">
                  <FormattedMessage
                    id="home-archive-stats-title"
                    defaultMessage="Tilastot"
                  />
                </h3>
              </div>

              <div className="col-auto ml-sm-auto">
                {answersLoading ? (
                  <button type="button" className="btn btn-primary">
                    <Spinner small center white />
                  </button>
                ) : (
                  <a
                    href={`/api/competitions/${statsCompetitionId}/series/${statsSeriesId}/answers?identifier=${identifier}`}
                    className="btn btn-primary"
                    onClick={this.onDownloadAnswers}
                  >
                    <i className="fas fa-download mr-3" />
                    <FormattedMessage
                      id="home-archive-stats-download-csv"
                      defaultMessage="Lataa vastausdata"
                    />
                  </a>
                )}
              </div>
            </div>

            <Stats
              stats={{ series: stats[statsSeriesId] }}
              base="series"
              showParticipation
            />
          </div>
        )}
      </div>
    );
  }
}

export default ArchiveStats;
